import { combineReducers } from "redux";
import { commitDemand } from "./commitDemand";
import { content } from "./content";
import { metadata } from "./metadata";
import { visible } from "./visible";

/** Manages state of modals displayed on the UI. */
export const modal = combineReducers({
  visible,
  content,
  metadata,
  commitDemand,
});
